<template>
  <multiselect
    :value="selected"
    class="ps"
    :class="{ invalid }"
    :options="options"
    label="text"
    track-by="value"
    :placeholder="placeholder"
    :searchable="searchable"
    :allow-empty="false"
    :show-labels="false"
    :disabled="disabled"
    @input="(option) => $emit('input', option.value)"
    @close="$emit('blur')"
  >
    <template #noResult>No hay resultados.</template>
    <template #noOptions>No hay opciones.</template>
  </multiselect>
</template>

<script>
// A dropdown for a field edited in place (PortalField's soft look), instead of the browser's own <select>: that
// one draws its list itself, tiny in Chrome's phone emulation. Rows are roomy, and a long list can be searched.
// Takes the wizard's options ([{ value, text }]) and emits the chosen option's value.
export default {
  name: "PortalSelect",
  props: {
    options: { type: Array, required: true },
    value: { default: "" },
    placeholder: { type: String, default: "Seleccione…" },
    searchable: { type: Boolean, default: false },
    invalid: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    selected() {
      if (this.value === "" || this.value === null || this.value === undefined) return null;
      return this.options.find((option) => String(option.value) === String(this.value)) || null;
    },
  },
};
</script>

<style scoped>
.ps {
  min-height: 44px;
  font-family: "Geist", system-ui, sans-serif;
  color: #0e1424;
}
.ps ::v-deep .multiselect__tags {
  min-height: 44px;
  padding: 11px 40px 0 14px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: #f4f5f8;
  transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
}
.ps:hover ::v-deep .multiselect__tags {
  background: #eef0f4;
}
.ps.multiselect--active ::v-deep .multiselect__tags {
  border-color: #e6b65c;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(230, 182, 92, 0.18);
}
.ps.invalid ::v-deep .multiselect__tags {
  border-color: #f2c0c0;
  background: #fff6f6;
}
.ps ::v-deep .multiselect__single,
.ps ::v-deep .multiselect__placeholder {
  display: block;
  margin: 0;
  padding: 0;
  background: transparent;
  font: 600 15px/20px "Geist", system-ui, sans-serif;
}
/* The search box of a long list: vue-multiselect sizes it itself (full width while open, hidden while closed), so
   it must not be given a width here, or its placeholder would sit over the chosen value. */
.ps ::v-deep .multiselect__input {
  min-height: 20px;
  margin: 0;
  padding: 0;
  background: transparent;
  font: 600 15px/20px "Geist", system-ui, sans-serif;
  color: #0e1424;
}
.ps ::v-deep .multiselect__input::placeholder {
  font-weight: 400;
  color: #a7adbb;
}
.ps ::v-deep .multiselect__placeholder {
  font-weight: 400;
  color: #a7adbb;
}
.ps ::v-deep .multiselect__select {
  top: 0;
  right: 0;
  width: 40px;
  height: 42px;
  padding: 0;
}
.ps ::v-deep .multiselect__select::before {
  top: 55%;
  border-color: #8a91a3 transparent transparent;
}
.ps ::v-deep .multiselect__content-wrapper {
  margin-top: 6px;
  border: 1px solid #e3e6ed;
  border-radius: 12px;
  box-shadow: 0 14px 28px -12px rgba(10, 16, 32, 0.25);
}
.ps ::v-deep .multiselect__option {
  min-height: 44px;
  padding: 13px 14px;
  font: 500 14px/18px "Geist", system-ui, sans-serif;
  color: #0e1424;
}
.ps ::v-deep .multiselect__option::after {
  display: none;
}
.ps ::v-deep .multiselect__option--highlight {
  background: #f4f5f8;
  color: #0e1424;
}
.ps ::v-deep .multiselect__option--selected {
  background: #fff7e8;
  font-weight: 600;
}
.ps ::v-deep .multiselect__option--selected.multiselect__option--highlight {
  background: #fdebc8;
}
.ps ::v-deep .multiselect__content .multiselect__option span {
  color: inherit;
}
/* Waiting for the field before it: the same rounded field, dimmed (vue-multiselect paints a square gray box behind). */
.ps.multiselect--disabled {
  border-radius: 10px;
  background: transparent;
  opacity: 1;
}
.ps.multiselect--disabled ::v-deep .multiselect__tags {
  background: #f4f5f8;
  opacity: 0.6;
}
.ps.multiselect--disabled ::v-deep .multiselect__select {
  background: transparent;
}
</style>
